{
    "name": "fieldapp4c.webapplication",
    "version": "2.16.4",
    "private": true,
    "engines": {
        "node": ">=22.18"
    },
    "dependencies": {
        "@casl/ability": "^6.8.0",
        "@casl/react": "^5.0.1",
        "@fortawesome/fontawesome-svg-core": "^7.3.1",
        "@fortawesome/free-regular-svg-icons": "^7.3.1",
        "@fortawesome/free-solid-svg-icons": "^7.3.1",
        "@fortawesome/react-fontawesome": "^3.5.0",
        "@hello-pangea/dnd": "^18.0.1",
        "@microsoft/signalr": "^10.0.11",
        "@reduxjs/toolkit": "^2.13.0",
        "@tanstack/react-query": "^5.105.0",
        "@vis.gl/react-google-maps": "^1.10.1",
        "ag-grid-community": "^30.2.1",
        "ag-grid-react": "^30.2.1",
        "bootstrap": "^5.3.8",
        "browser-image-compression": "^2.0.2",
        "clsx": "^2.1.1",
        "email-validator": "^2.0.4",
        "i18next": "^26.5.11",
        "i18next-browser-languagedetector": "^8.2.3",
        "lodash-es": "^4.18.1",
        "moment": "^2.31.0",
        "moment-timezone": "^0.6.5",
        "oidc-client-ts": "^3.5.0",
        "rc-time-picker": "^3.7.3",
        "react": "^18.3.1",
        "react-big-calendar": "^1.20.0",
        "react-datepicker": "^9.1.0",
        "react-dom": "^18.3.1",
        "react-dropzone": "^20.1.4",
        "react-helmet": "^6.1.0",
        "react-i18next": "^17.1.9",
        "react-modal-sheet": "^5.6.0",
        "react-router": "^5.3.4",
        "react-router-dom": "^5.3.4",
        "react-select": "^5.10.2",
        "react-signature-canvas": "^1.0.7",
        "react-split": "^2.0.14",
        "react-toastify": "^11.1.0",
        "reactstrap": "^9.2.3",
        "redux-first-history": "^5.2.0",
        "redux-persist": "^6.0.0",
        "sanitize-filename": "^1.6.4",
        "source-map-explorer": "^2.5.3",
        "supercluster": "^9.1.0",
        "uuid": "^14.0.3",
        "xlsx": "^0.18.5"
    },
    "devDependencies": {
        "@babel/eslint-parser": "^8.0.7",
        "@eslint-react/eslint-plugin": "^2.3.7",
        "@eslint/compat": "^2.1.1",
        "@eslint/eslintrc": "^3.3.7",
        "@eslint/js": "^9.39.5",
        "@tanstack/eslint-plugin-query": "^5.105.0",
        "@testing-library/react": "^16.3.3",
        "@types/lodash-es": "^4.17.12",
        "@types/node": "^24.19.2",
        "@types/pg": "^8.23.1",
        "@types/react-router-dom": "^5.3.3",
        "@vitejs/plugin-react": "^6.1.2",
        "@vitest/coverage-v8": "^5.0.5",
        "cypress": "^16.2.0",
        "eslint": "^9.39.5",
        "eslint-import-resolver-typescript": "^4.4.5",
        "eslint-plugin-cypress": "^6.4.1",
        "eslint-plugin-editorconfig": "^4.0.3",
        "eslint-plugin-import": "^2.32.0",
        "eslint-plugin-jsx-a11y": "^6.10.2",
        "eslint-plugin-react": "^7.37.5",
        "eslint-plugin-react-hooks": "^5.2.0",
        "faker": "^6.6.6",
        "globals": "^17.13.0",
        "jiti": "^2.7.0",
        "jsdom": "^30.1.3",
        "pg": "^8.23.1",
        "rimraf": "^6.1.3",
        "sass": "^1.106.1",
        "type-fest": "^5.10.0",
        "typescript": "^6.0.3",
        "typescript-eslint": "^8.72.1",
        "vite": "^8.3.5",
        "vitest": "^5.0.5",
        "yaml": "^2.9.1"
    },
    "overrides": {
        "ag-grid-react": {
            "react": "$react",
            "react-dom": "$react-dom"
        },
        "typescript-eslint": {
            "typescript": "$typescript"
        },
        "@eslint-react/eslint-plugin": {
            "typescript": "$typescript"
        },
        "@babel/eslint-parser": {
            "eslint": "$eslint"
        },
        "@tanstack/eslint-plugin-query": {
            "eslint": "$eslint",
            "typescript": "$typescript"
        },
        "eslint-plugin-import": {
            "eslint": "$eslint"
        },
        "eslint-plugin-jsx-a11y": {
            "eslint": "$eslint"
        },
        "eslint-plugin-react": {
            "eslint": "$eslint"
        }
    },
    "scripts": {
        "analyze": "source-map-explorer 'build/assets/*.js'",
        "generate-build-version": "node generate-build-version.mts",
        "start": "npm run generate-build-version && rimraf ./build && vite",
        "build": "tsc --noEmit && vite build",
        "typecheck": "tsc --noEmit",
        "preview": "vite preview",
        "test": "vitest run",
        "test:coverage": "vitest run --coverage --coverage.include='src/@s20/common/util/**/*.ts' --coverage.include='src/@s20/services/**/*.tsx' src/@s20/common/util src/@s20/services",
        "lint": "eslint ./src/ ./testing/cypress/ --fix"
    }
}
